// extracted by mini-css-extract-plugin
export default {"container":"Qqun4qtV","scoreText":"GsKTjeB7"};